import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication-service.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private autheService: AuthenticationService, private router: Router,) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if account is logged in and request is to the api url
    console.log("intercept");


    let token = localStorage.getItem('token');
    const tokenERP = localStorage.getItem('tokenERP');
    if (request.url.startsWith(environment.restApiERP)) {
      token = tokenERP;
      //  console.log("tokenERP",tokenERP);

    }

    if (request.url.startsWith(environment.restApiAncienERP)) {
      token = localStorage.getItem('tokenAncienERP');
      //  console.log("tocken",token);

    }




    const isLoggedIn = token;

    const isApiUrl = request.url.startsWith(environment.adresseUrl);

    const a = request.url.endsWith("utilisateurs/loginUs")


    if (isLoggedIn && isApiUrl && !a) {
      console.log("yes");


      request = request.clone({
        setHeaders: {

          "Access-Control-Allow-Headers": "x-access-token, access-control-allow-origin, Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",

          "x-access-token": token
        }



      });



    }
    else
      console.log("noooo");



    return next.handle(request).pipe(tap(() => { },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }

          this.autheService.logout()
          this.router.navigateByUrl("login")
        }
      }));
  };

}